import * as types from "./mutation-types";

const mutations = {
  [types.SET_GUIDE](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_STRATEGY](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_ARTICLE](state, data) {
    state[data.key] = data.value;
  },
  [types.SET_ARTICLES](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_TOPIC](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_WORKSHOP](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_WORKSHOP_REG_STATE](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_TOPICS](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_WORKSHOPS](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_ASSESSMENT_DATA](state, data) {
    state[data.key] = data.value;
  },

  [types.SET_ASSESSMENT_STATE](state, data) {
    state[data.key] = data.value;
  }
};

export default mutations;
